<template>

</template>

<script>
  export default {
    name: "logOut",
    created(){
      localStorage.removeItem('user-token');
      document.location.href = '/'
    }
  }
</script>

<style scoped>

</style>
